<div fxLayout="column" fxLayoutAlign="center">
  @if (company.trialStatus && company.remainingTrialDays == 0) {
    <span fxLayoutAlign="center center" class="status">
      Company @if (company.remainingTrialDays > 0) {
      <span> {{ company.remainingTrialDays }}-Days </span>
      } free trial
      account has
      expired @if (isAdmin) {
        and you can no longer create and
        manage campaigns. &nbsp; <a routerLink="account/license-management" class="btn btn-xs btn-info "> BUY LICENSES
      NOW </a> &nbsp; to enjoy all the features of {{applicationNameService.getApplicationName()}}.
    }
  </span>
}
@if (user.keyExpire) {
  <span fxLayoutAlign="center center" class="status">
    Your cloud provider API token has expired @if (isAdmin) {
    <span> &nbsp; and you can no longer
      create and manage
    campaigns.</span>
  }
</span>
}
@if (user.licenseExpired) {
  <span fxLayoutAlign="center center" class="status">
    Your {{applicationNameService.getApplicationName()}} license has expired.  To avoid any disruption in your tenant, please contact {{applicationNameService.getApplicationName()}} regarding payment.
  </span>
}
@if (company.trialStatus && company.remainingTrialDays > 0) {
  <span fxLayoutAlign="center center" class="bg-yellow">
    {{company.remainingTrialDays}} Days left in your free trial.&nbsp;@if (isAdmin) {
    <span> &nbsp; <a
      routerLink="account/license-management" class="btn btn-xs btn-info "> "BUY LICENSES
    NOW" </a> &nbsp; and enjoy uninterrupted access to your {{applicationNameService.getApplicationName()}} Tenant. </span>
  }</span>
}
</div>

<div class="toolbar" fxLayout="row" fxLayoutAlign="space-between center">
  <div class="toolbar-left" fxLayout="row" fxLayoutAlign="start center">
    <div [fxShow.gt-sm]="topNavigation$ | async" [fxShow.xs]="false" [routerLink]="['/']" class="toolbar-logo" fxShow>
      <div class="fill-primary-contrast">
        <img src="../../../assets/images/atlogo.png" class="dashboardlogo" alt="">
      </div>
    </div>
    <fury-toolbar-search-bar fxFlex="460px" fxHide fxShow.gt-md></fury-toolbar-search-bar>
  </div>

  <div class="toolbar-actions" fxLayout="row" fxLayoutAlign="start center">
    @if (canShowReportDownload) {
      <button class="action-btn" (click)="openReportDownloadDialog()" fxHide fxShow.gt-sm mat-icon-button matTooltipClass="toolbar-info-tooltip"
        matTooltip="Download Audit Report">
        <mat-icon>file_download</mat-icon>
      </button>
    }

    <fury-toolbar-fullscreen-toggle class="toolbar-item"></fury-toolbar-fullscreen-toggle>

    <fury-toolbar-search fxHide fxShow.gt-sm fxHide.gt-md class="toolbar-item"></fury-toolbar-search>

    <fury-toolbar-notifications class="toolbar-item"></fury-toolbar-notifications>

    <fury-toolbar-info class="toolbar-item"></fury-toolbar-info>

    <div class="toolbar-divider" fxHide fxShow.gt-sm></div>

    <fury-toolbar-user class="toolbar-item toolbar-item-user"></fury-toolbar-user>
  </div>
</div>